"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutcodePostcodeLocationResponse$ = exports.OutcodePostcodeLocationResponse$outboundSchema = exports.OutcodePostcodeLocationResponse$inboundSchema = void 0;
exports.outcodePostcodeLocationResponseToJSON = outcodePostcodeLocationResponseToJSON;
exports.outcodePostcodeLocationResponseFromJSON = outcodePostcodeLocationResponseFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const outcodepostcodelocationwrapper_js_1 = require("./outcodepostcodelocationwrapper.js");
/** @internal */
exports.OutcodePostcodeLocationResponse$inboundSchema = z.object({
    data: outcodepostcodelocationwrapper_js_1.OutcodePostcodeLocationWrapper$inboundSchema,
});
/** @internal */
exports.OutcodePostcodeLocationResponse$outboundSchema = z.object({
    data: outcodepostcodelocationwrapper_js_1.OutcodePostcodeLocationWrapper$outboundSchema,
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var OutcodePostcodeLocationResponse$;
(function (OutcodePostcodeLocationResponse$) {
    /** @deprecated use `OutcodePostcodeLocationResponse$inboundSchema` instead. */
    OutcodePostcodeLocationResponse$.inboundSchema = exports.OutcodePostcodeLocationResponse$inboundSchema;
    /** @deprecated use `OutcodePostcodeLocationResponse$outboundSchema` instead. */
    OutcodePostcodeLocationResponse$.outboundSchema = exports.OutcodePostcodeLocationResponse$outboundSchema;
})(OutcodePostcodeLocationResponse$ || (exports.OutcodePostcodeLocationResponse$ = OutcodePostcodeLocationResponse$ = {}));
function outcodePostcodeLocationResponseToJSON(outcodePostcodeLocationResponse) {
    return JSON.stringify(exports.OutcodePostcodeLocationResponse$outboundSchema.parse(outcodePostcodeLocationResponse));
}
function outcodePostcodeLocationResponseFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.OutcodePostcodeLocationResponse$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'OutcodePostcodeLocationResponse' from JSON`);
}
//# sourceMappingURL=outcodepostcodelocationresponse.js.map